import { combineReducers } from 'redux';
import actInfo from './actinfo';
import goodInfo from './goodinfo';
import filterInfo from './prosale-filter';

export default combineReducers({ actInfo, goodInfo, filterInfo });
